import environment from "../../environment/environment";

export default class SensorsUtils {
    static getBackgroundSensor(cropType) {
        switch (cropType) {
            case 'Flores':
                return environment.roses;
            case 'Aguacate':
                return environment.avocado;
            case 'Café':
                return environment.coffee;
            case 'Palma':
                return environment.palm;
            case 'Tomate':
                return environment.tomatoes;
            case 'Gulupa':
                return environment.gulupa;
            case 'Arándanos':
                return environment.blueberries;
            case 'Aromáticas':
                return environment.peppermint;
            default:
                return environment.plants;
        }
    }

    static getUpdateLabel(minutes) {
        if (minutes === undefined || minutes === null) return "N/A";
        if (minutes < 1) return "Justo ahora";
        if (minutes < 60) return `Hace ${minutes} min`;
        if (minutes < 1440) {
            const hours = Math.floor(minutes / 60);
            return `Hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
        }
        const days = Math.floor(minutes / 1440);
        return `Hace ${days} ${days === 1 ? 'día' : 'días'}`;
    }

    static getUpdateBadgeClass(minutes) {
        if (minutes === undefined || minutes === null) return "bg-gray-100 text-gray-400";
        if (minutes < 60) return "bg-green-500 text-white";
        if (minutes < 180) return "bg-orange-500 text-white";
        return "bg-red-500 text-white";
    }

    // Same icon/color set used in the "Mis cultivos" climate header (TA/HA/Rd),
    // extended here with the rest of the variables shown in "Datos actuales".
    static getVariableIcon(variableId) {
        switch (variableId) {
            case 'TA':
                return { icon: 'thermostat', color: 'text-yellow-500' };
            case 'HA':
                return { icon: 'water_drop', color: 'text-blue-500' };
            case 'Rd':
                return { icon: 'light_mode', color: 'text-orange-400' };
            case 'HS':
                return { icon: 'grass', color: 'text-green-600' };
            case 'PH':
            case 'PH2':
            case 'PH3':
                return { icon: 'science', color: 'text-purple-500' };
            case 'CE':
            case 'CE2':
            case 'CE3':
                return { icon: 'bolt', color: 'text-indigo-500' };
            case 'VB':
                return { icon: 'battery_full', color: 'text-gray-700' };
            case 'RHS':
                return { icon: 'water', color: 'text-cyan-600' };
            default:
                return { icon: 'sensors', color: 'text-gray-500' };
        }
    }
}